import type { IQuest } from 'components/quests/loyalty-quest/types';

export const getProductRequirementCmsIds = (quest: IQuest | undefined): string[] => {
  if (!quest || !quest?.steps) {
    return [];
  }

  const uniqueCmsIds = quest.steps.reduce((stepIdSet, step) => {
    return step.cartRequirements?.reduce((cartReqIdSet, cartReq) => {
      return cartReq?.reduce((prodReqIdSet, prodReq) => {
        return prodReqIdSet.add(prodReq?.id);
      }, cartReqIdSet);
    }, stepIdSet);
  }, new Set<string>());

  return Array.from(uniqueCmsIds ?? []);
};
